import { tenantApi } from '../../api/endpoints/tenant';
import { apiUserApi } from '../../api/endpoints/apiUsers';
import { UserActionsMenu } from '../shared/UserActionsMenu';
import { useLabelResolver } from '../../hooks/useLabelResolver';
import type { TenantUserListItemLocal } from '../../api/types/TenantLocal';

interface Props {
    user: TenantUserListItemLocal;
    tid: string;
}

/**
 * Menú "⋮" de acciones por fila de usuario del tenant propio. Delega en `UserActionsMenu` (compartido
 * con retailer y el drill-down platform) inyectando el binding `tenantApi.*`, los permisos `tenant.user.*`
 * y el scope TENANT/tid. El backend re-enforza cada permiso.
 */
export function UserRowActions({ user, tid }: Props) {
    const sub = user.cognitoSub;
    const labels = useLabelResolver();
    return (
        <UserActionsMenu
            user={user}
            tenantId={tid}
            labels={labels}
            gateScope="TENANT"
            gateScopeRef={tid}
            api={{
                getDetail: () => tenantApi.getUser(tid, sub),
                update: (body) => tenantApi.updateUser(tid, sub, body),
                disable: () => tenantApi.disableUser(tid, sub),
                enable: () => tenantApi.enableUser(tid, sub),
                delete: () => tenantApi.deleteUser(tid, sub),
                resetPassword: () => tenantApi.resetPassword(tid, sub),
                resetMfa: () => tenantApi.resetMfa(tid, sub),
                resendInvitation: () => tenantApi.resendInvitation(tid, sub),
                rotateApiSecret: () => apiUserApi.rotateSecret(tid, sub),
                updateApiAccess: (body) => apiUserApi.updateAccess(tid, sub, body),
            }}
            perms={{
                update: 'tenant.user.update',
                passwordReset: 'tenant.user.password.reset',
                mfaReset: 'tenant.user.mfa.reset',
                status: 'tenant.user.status',
                delete: 'tenant.user.delete',
            }}
            detailQueryKey={['tenant', tid, 'users', sub, 'detail']}
            listQueryKey={['tenant', tid, 'users']}
        />
    );
}
